(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MedalDeleteController',MedalDeleteController);

    MedalDeleteController.$inject = ['$uibModalInstance', 'entity', 'Medal'];

    function MedalDeleteController($uibModalInstance, entity, Medal) {
        var vm = this;

        vm.medal = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Medal.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
